import React from 'react';
import { useTranslation } from 'react-i18next';
import translations from "../../Components/Translations/Translations.json";

const Mobileweekdays = () => {
    const { t } = useTranslation();
    const storedLanguage = localStorage.getItem("lang") || "en";
    const selectedTranslation = translations[storedLanguage] || translations.en;

    const weekdays = [
        { name: "Monday", key: "monday", isActive: true },
        { name: "Tuesday", key: "tuesday" },
        { name: "Wednesday", key: "wednesday" },
        { name: "Thursday", key: "thursday" },
        { name: "Friday", key: "friday" },
        { name: "Saturday", key: "saturday" },
        { name: "Sunday", key: "sunday" },
    ];

    return (
        <div className="grid justify-center grid-cols-7 gap-2 mt-10 mb-3 text-center">
            {weekdays.map(({ name, key, isActive }) => (
                <div
                    key={key}
                    className={`flex flex-col items-center justify-center rounded-lg text-[8px] ${isActive ? 'bg-[#FF695F] text-white' : 'bg-[#F6F6F6]'}`}
                    style={{ height: '30px', width: '50px' }}
                >
                    <div>{name}</div>
                    <div>
                        <span className="text-[8px]">{t(selectedTranslation.labels[key])}</span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Mobileweekdays;
